import { HttpClient } from '@wix/http-client';

const baseURL = window.__BASEURL__ || 'https://editor.wix.com';

export const httpClientHeader = {
  artifactId: 'discovery-client',
  'X-Wix-Client-Artifact-Id': 'discovery-client'
};

export const httpClient = new HttpClient({ baseURL });

